export default __webpack_public_path__ + "static/media/acoustic-guitars-ambient-uplifting-background-music-for-videos-5642.62157bdc.mp3";